/**
 * @author vishwadeep.kapoor
 * @Date: 2020-11-20 16:57:13
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-20 18:46:13
 */

import React from 'react';
import { shape } from 'prop-types';
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Trusted from '../Trusted';
import Journey from '../Journey';
import StyledSolutions from './StyledSolutions';
import Corporate from './Corporate';
import StartUp from './StartUp';
import SME from './SME';
import LandingContainer from '../../../components/LandingContainer';
import endPoints from '../../../config/endPoints';
import { constants } from '../../../devUtils';
import { AppWrappperHOC } from '../../Root/HOC';
import { HelmetWrapper } from '../../../components';

const SwitchSolutionRoute = (type) => {
  switch (type) {
    case 'corporate':
      return <Corporate />;
    case 'startup':
      return <StartUp />;
    case 'sme':
      return <SME />;
    default:
      return null;
  }
};

const TABS_LINKS = [
  {
    label: 'Startup',
    link: '/solutions/startup',
    tabType: 'startup',
  },
  {
    label: 'SME',
    link: '/solutions/sme',
    tabType: 'sme',
  },
  {
    label: 'Corporate',
    link: '/solutions/corporate',
    tabType: 'corporate',
  },
];
const SolutionWrapper = (props) => {
  const { match: { params: { type } = {} }, location } = props;
  return (
    <StyledSolutions>
      <HelmetWrapper location={location} />
      <section className="padding-tb-5">
        <LandingContainer>
          <Row align="middle" type="flex" gutter={16}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <h1 className="font-36">Solutions Built for Everyone</h1>
              <p>Zaggle is the one-time solution for all types of businesses from<br />start-ups, SMEs, and huge corporates in building automated<br />expense and reward systems.</p>
              {/* <Link to="/" className="btn white-btn">SCHEDULE A DEMO</Link> */}
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <img
                src={endPoints.SOLUTIONS_STARTUP.URL}
                alt={endPoints.SOLUTIONS_STARTUP.ALT}
                className="width-100 img-grayscale"
              />
            </Col>
          </Row>
        </LandingContainer>
      </section>
      <section className="tabs">
        <Link to={constants.LINK_ABOUT_US}>
          <img src={endPoints.ZAGGLE_EMBLEM.URL} alt={endPoints.ZAGGLE_EMBLEM.ALT} className="zaggle-emblem" />
        </Link>
        <LandingContainer>
          <ul>
            {TABS_LINKS.map(({ link, label, tabType }) => (
              <li key={link}>
                <Link to={link} className={tabType === type ? 'active' : ''}>{label}</Link>
              </li>))}
          </ul>
        </LandingContainer>
      </section>
      {SwitchSolutionRoute(type)}
      <Trusted />
      <Journey />
    </StyledSolutions>);
};

SolutionWrapper.propTypes = {
  match: shape({}).isRequired,
  location: shape({}).isRequired,
};
export default AppWrappperHOC(SolutionWrapper);



// WEBPACK FOOTER //
// client/containers/NewLanding/Solutions/index.jsx